import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import allPlugins from "../../utils/suneditorPlugins";
import "./CreateContract.css";
import SideCanvas from "./SideCanvas";
import TextEditorToSection from "./TextEditorToSection";
import { useDispatch, useSelector } from "react-redux";
import { setTitle } from "../../redux/titleSlice";
import apiClient, { getEditorUploadConfig } from '../../services/apiClient';
import Swal from "sweetalert2";
import { getErrorMessage } from "../../services/errorHelper";
import { useNavigate } from "react-router-dom/dist/umd/react-router-dom.development";

export default function CreateContract() {
  // Reference for the SunEditor instance
  const editorRef = useRef(null);
  const [contractCount, setContractCount] = useState(1);
  const [selectedValue1, setSelectedValue1] = useState("");
  const [editorInstance, setEditorInstance] = useState(null);

  const title = useSelector((state) => state.title.title);
  const [tabs, setTabs] = useState([
    {
      id: "v-pills-home",
      title: "Contract",
      content: `<div>
        <h1>Contract</h1>
        <p className="mt-5">Please type or copy and paste the content of your contract here. Alternatively, you can import one of your contract templates using the right panel. </p> 
        <p className="mt-5">If you don’t have a contract, you can browse our template gallery for lawyer-approved free contracts.</p> 
        <p className="mt-5">And remember to delete this text before sending.</p>
        <p className="smart_text">smart_text</p>
      </div>`,
    },
  ]);
  const navigate = useNavigate();

  const handleEditorChange = (content, tabId) => {
    setTabs((prevTabs) =>
      prevTabs.map((tab) =>
        tab.id === tabId ? { ...tab, content: content } : tab
      )
    );
  };

  const handleSelectChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue1(newValue); // Update state
  };
  const renamepage = (tabId) => {
    const newTitle = prompt("Enter a new title for the page:");
    if (newTitle) {
      setTabs((prevTabs) =>
        prevTabs.map((tab) =>
          tab.id === tabId ? { ...tab, title: newTitle } : tab
        )
      );
    }
  };

  const getSunEditorInstance = (sunEditor) => {
    editorRef.current = sunEditor;
    setEditorInstance(sunEditor);
  };

  const handleInsertInputField1 = () => {
    document.getElementById("smarttextpopup").click();
  };

  const handleInsertInputField = () => {
    const value = selectedValue1;
    if (!value) {
      Swal.fire({
        icon: "warning",
        title: "Select a field",
        text: "Please choose a smart text field first!",
      });
      return;
    }
    const inputFieldHTML = `${value}`;
    try {
      if (editorInstance) {
        editorInstance.core.focus();
        editorInstance.insertHTML(inputFieldHTML);
      }
    } catch (error) {
      console.error("[SUNEDITOR.insertHTML.fail]", error);
    }
  };

  useEffect(() => {
    const buttonid = `v-pills-${contractCount}-tab`;
    const activebutton = document.getElementById(buttonid);

    if (activebutton) {
      activebutton.click();
    }

    if (contractCount > 1) {
      const popupBtn = document.getElementById("smarttextpopup");
      if (popupBtn) {
        popupBtn.click();
      }
    }
  }, [tabs.length, contractCount]);

  useEffect(() => {
    const addCustomButton = () => {
      const sunEditorToolbar = document.querySelector(".active .se-menu-list");

      if (
        sunEditorToolbar &&
        editorInstance &&
        editorInstance.core &&
        !sunEditorToolbar.querySelector(".customAction") // prevent duplicates
      ) {
        const customButton = document.createElement("button");
        customButton.classList.add("sun-editor-action", "customAction", "p-3");
        customButton.type = "button";
        customButton.setAttribute("title", "Add Smart Text");

        // Icon + tooltip, styled like SunEditor
        customButton.innerHTML = `<i class="fa fa-magic"></i>`;

        customButton.addEventListener("click", handleInsertInputField1);

        sunEditorToolbar.appendChild(customButton);
      }
    };

    // Run whenever editor mounts OR active tab changes
    if (editorInstance && editorInstance.core) {
      setTimeout(addCustomButton, 200);
    }
  }, [editorInstance, tabs.length, contractCount]);

  const handleSubmit = async () => {
    try {
      const response = await apiClient.post(
        `/contracts`,
        {
          title: title,
          user_id: JSON.parse(localStorage.getItem("user")).user.id,
          pages: tabs.map((tab) => ({
            content: tab.content,
            page_name: tab.title,
          })),
        }
      );
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Contract saved successfully!",
      });
      navigate("/contracts");
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: getErrorMessage(error),
      });
    }
  };

  // Options for the SunEditor instance
  const editorOptions = {
    height: 200,
    plugins: allPlugins,
    ...getEditorUploadConfig(),
    buttonList: [
      [
        "codeView",
        "paragraphStyle",
        "bold",
        "underline",
        "italic",
        "strike",
        "table",
        "link",
        "horizontalRule",
        "list",
        "align",
        "hiliteColor",
        "image",
        "video",
      ],
    ],
    imageRotation: false,
    fontSize: [12, 14, 16, 18, 20],
    colorList: [
      [
        "#828282",
        "#FF5400",
        "#676464",
        "#F1F2F4",
        "#FF9B00",
        "#F00",
        "#fa6e30",
        "#000",
        "rgba(255, 153, 0, 0.1)",
        "#FF6600",
        "#0099FF",
        "#74CC6D",
        "#FF9900",
        "#CCCCCC",
      ],
    ],
  };

  // Function to handle adding a new contract page
  const handleAddContract = () => {
    const newTabId = `v-pills-${contractCount + 1}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: `<div>
        <h1>${newTabTitle}</h1>
        <p className="mt-5">Your new page content goes here.</p>
      </div>`,
    };

    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 1);

    document.getElementById("offcanvasRight2").classList.remove("show");
    document.getElementById("offcanvasRight2").style.visibility = "hidden";
  };

  const handleClick = (id) => {
    setTabs((prevTabs) => prevTabs.filter((item) => item.id !== id));
  };

  const handleclone = (cloneid) => {
    const clonetab = tabs.filter((item) => item.id === cloneid);
    const newTabId = `v-pills-${contractCount + 2}`;
    const newTabTitle = `Page ${contractCount + 1}`;

    const newTab = {
      id: newTabId,
      title: newTabTitle,
      content: clonetab[0].content,
    };

    setTabs([...tabs, newTab]);
    setContractCount((prevCount) => prevCount + 2);
  };

  return (
    <>
      {/* Side canvas for the smart text */}
      <SideCanvas
      // Pass the function to handle smart text input change
      />
      <div className="container-fluid p-lg-5 p-md-5 p-3">
        <div className="row g-lg-5 row_mobile g-md-5 g-3 px-lg-5">
          {/* Text Editor part */}
          <div className="col-md-9">
            <div className="text-editor px-2 px-md-5 py-3">
              <div className="tab-content h-100" id="v-pills-tabContent">
                {/* text editor page */}

                {tabs.map((tab) => (
                  <div
                    key={tab.id}
                    className={
                      "tab-pane fade " +
                      (tab.id == "v-pills-home" ? "show active" : "")
                    }
                    id={tab.id}
                    role="tabpanel"
                    aria-labelledby={`${tab.id}-tab`}
                  >
                    {tab.id == "v-pills-home" ? <TextEditorToSection /> : ""}
                    <div className="position-relative overflow-hidden">
                      <SunEditor
                        setOptions={editorOptions}
                        ref={editorRef}
                        defaultValue={tab.content}
                        onChange={(content) =>
                          handleEditorChange(content, tab.id)
                        }
                        getSunEditorInstance={getSunEditorInstance}
                      />
                    </div>
                  </div>
                ))}

                {/* add page */}
                <div
                  className="tab-pane fade h-100  text-center"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div className="add-page  d-flex flex-column justify-content-center align-items-center"></div>
                </div>
              </div>
            </div>
          </div>

          {/* Contract Right Area */}
          <div className="col-md-8 col-lg-3">
            <span className="placeholder col-6"></span>

            <div className="row">
              <div className="col-12">
                <div className="right-side-area">
                  <div
                    className="nav flex-column nav-pills me-3"
                    id="v-pills-tab"
                    role="tablist"
                    aria-orientation="vertical"
                  >
                    {/* Current Page Start: Contract Box */}
                    {tabs.map((tab) => (
                      <button
                        key={tab.id}
                        className={`nav-link ${
                          tab.id === "v-pills-home" ? "active" : ""
                        }`}
                        id={`${tab.id}-tab`}
                        data-bs-toggle="pill"
                        data-bs-target={`#${tab.id}`}
                        type="button"
                        role="tab"
                        aria-controls={tab.id}
                        aria-selected={
                          tab.id === "v-pills-home" ? "true" : "false"
                        }
                      >
                        <div className="right-side-box">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center">
                              <div
                                className="icon-box active bg-white"
                                role="button"
                              >
                                <div className="row gap-2 align-items-start m-2">
                                  <div className="col-12 skeleton-one"></div>
                                  <div className="col-12 skeleton-two"></div>
                                  <div className="col-12 skeleton-three"></div>
                                  <div className="col-12 skeleton-four"></div>
                                </div>
                              </div>
                              <h5 className="box-title">{tab.title}</h5>
                            </div>
                            <div
                              className="nav-item dropdown"
                              id="top-user-nav"
                            >
                              <div
                                className="nav-link dropdown"
                                data-bs-toggle="dropdown"
                              >
                                <div className="three-dot-btn">
                                  <button
                                    className="border-0 bg-transparent"
                                    type="button"
                                  >
                                    <i className="fa-solid fa-ellipsis-vertical"></i>
                                  </button>
                                </div>
                              </div>
                              <div className="dropdown-menu shadow-sm border-0 py-4 px-4">
                                <Link to="#">
                                  <div
                                    className="link-btn mb-4 rename-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => renamepage(tab.id)}
                                  >
                                    <i
                                      className="fa fa-pencil"
                                      aria-hidden="true"
                                    ></i>
                                    <span>Rename</span>
                                  </div>
                                </Link>
                                <Link to="#">
                                  <div
                                    className="link-btn mb-4 duplicate-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => handleclone(tab.id)}
                                  >
                                    <i className="fa-solid fa-clone"></i>
                                    <span>Duplicate</span>
                                  </div>
                                </Link>
                                <Link to="#">
                                  <div
                                    className="link-btn text-danger delete-page-btn"
                                    data-tab={tab.id}
                                    onClick={() => handleClick(tab.id)}
                                  >
                                    <i className="fa-solid fa-trash"></i>
                                    <span>Delete</span>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </button>
                    ))}
                    {/* Current Page End: Contract Box */}

                    {/* Add Page Start: New Page */}
                    <button
                      className="nav-link"
                      id="v-pills-profile-tab"
                      onClick={handleAddContract}
                      type="button"
                      role="tab"
                      aria-controls="v-pills-profile"
                      aria-selected="false"
                    >
                      {/* Add Page: New Page */}
                      <div className="right-side-box">
                        <div className="d-flex align-items-center justify-content-between">
                          <div
                            data-bs-toggle="offcanvas"
                            data-bs-target="#offcanvasRight2"
                            aria-controls="offcanvasRight2"
                            className="d-flex align-items-center"
                          >
                            <div
                              className="icon-box icon-box-add-page"
                              role="button"
                            >
                              <span>
                                <i className="fa-solid fa-plus"></i>
                              </span>
                            </div>
                            Add
                          </div>
                          {/* Dropdown */}
                          <div
                            className="nav-item dropdown"
                            id="top-user-nav"
                            aria-disabled="true"
                          >
                            <div
                              href="#"
                              className="nav-link dropdown"
                              data-bs-toggle="dropdown"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                    {/* Add Page End: New Page */}

                    <div
                      id="smarttextpopup"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasRight2"
                      aria-controls="offcanvasRight2"
                      className="d-flex align-items-center"
                    ></div>
                  </div>

                  <div className="text-center pt-2">
                    <button
                      id="submit-btn"
                      type="button"
                      className="px-5 rounded-pill btn btn-primary btn-lg text-uppercase"
                      onClick={handleSubmit}
                    >
                      Save
                    </button>
                  </div>

                  {/* Add page canvas */}
                  <div className="create-contract">
                    <div
                      className="offcanvas offcanvas-end"
                      tabindex="-1"
                      id="offcanvasRight2"
                      aria-labelledby="offcanvasRightLabel"
                      data-bs-backdrop="false"
                    >
                      <div className="w-100 text-start header">
                        <button
                          type="button"
                          className="btn-close mt-3 ms-4 text-black"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>

                        <div className="text-center py-3">
                          <h5>Smart Text</h5>
                        </div>
                      </div>
                      <div className="w-100 text-start header"></div>

                      <div className="offcanvas-body p-0">
                        <div className="single_box mt-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h6>Field content types: {selectedValue1}</h6>
                              <select
                                value={selectedValue1}
                                onChange={handleSelectChange}
                                style={{
                                  width: "300px",
                                  height: "40px",
                                  outline: "none",
                                  backgroundColor: "#ffffff",
                                  border: "1px solid #e8e4e4",
                                }}
                              >
                                <option value="" disabled selected>
                                  Select your option
                                </option>
                                <option value="{Event_Name}">Event Name</option>
                                <option value="{First_Client_First_Name}">
                                  First Client First Name
                                </option>
                                <option value="{First_Client_Last_Name}">
                                  First Client Last Name
                                </option>
                                <option value="{First_Client_Email}">
                                  First Client Email
                                </option>
                                <option value="{Event_Location}">Event Location</option>
                                <option value="{Event_Date}">Event Date</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        {/* <div className="single_box mt-4">
                          <div className="d-flex align-items-center justify-content-between">
                            <div>
                              <h6>Placeholder text</h6>
                              <div className="d-flex align-items-center mt-1">
                                <input
                                  placeholder="EX.client name"
                                  style={{
                                    width: "300px",
                                    height: "40px",
                                    outline: "none",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #e8e4e4",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div> */}

                        <div className="single_box mt-4">
                          <div className="d-flex align-items-center justify-content-between">
                            <button
                              onClick={handleInsertInputField}
                              style={{
                                width: "100px",
                                height: "40px",
                                borderRadius: "20px",
                                outline: "none",
                                backgroundColor: "#4f46e5",
                                border: "1px solid #e8e4e4",
                                color: "#fff",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                              }}
                            >
                              Insert
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
